export const ResortsConstants = {
    FETCHING_RESORTS:'FETCHING_RESORTS',
    FETCHING_RESORTS_SUCCESS:'FETCHING_RESORTS_SUCCESS',
    FETCHING_RESORTS_FAILURED:'FETCHING_RESORTS_FAILURED',
    SETTING_CURRENT_RESORT:'SETTING_CURRENT_RESORT',
    FETCHING_CITIES:'FETCHING_CITIES',
    FETCHING_CITIES_SUCCESS:'FETCHING_CITIES_SUCCESS',
    FETCHING_CITIES_FAILURED:'FETCHING_CITIES_FAILURED',
    FETCHING_ROOMS:'FETCHING_ROOMS',
    FETCHING_ROOMS_SUCCESS:'FETCHING_ROOMS_SUCCESS',
    FETCHING_ROOMS_FAILURED:'FETCHING_ROOMS_FAILURED',
    SETTING_CURRENT_PLACE:'SETTING_CURRENT_PLACE',
    SETTING_CURRENT_ROOM:'SETTING_CURRENT_ROOM'
}